import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '../base/api.service';
import {GenericItemResponse} from '../../entities/base/generic-item-response';
import {GenericCollectionResponse} from '../../entities/base/generic-collection-response';
import {BaseResponse} from '../../entities/base/base-response';
import {WebPushSubscription} from './entities/web-push-subscription';

@Injectable({
  providedIn: 'root'
})
export class WebPushRepositoryService {
  private api = inject(ApiService);

  getVapidPublicKey(): Observable<string> {
    return this.api.get<GenericItemResponse<string>>('/web-push/vapid-public-key')
      .pipe(map(r => r.value));
  }

  subscribe(subscription: PushSubscriptionJSON): Observable<number> {
    const p256dh = subscription.keys?.['p256dh'];
    const auth = subscription.keys?.['auth'];
    if (!p256dh || !auth) {
      throw new Error('Push subscription is missing required encryption keys (p256dh or auth)');
    }
    const body = {
      endpoint: subscription.endpoint,
      p256dh,
      auth,
      userAgent: navigator.userAgent
    };
    return this.api.post<GenericItemResponse<number>>('/web-push/subscriptions', body)
      .pipe(map(r => r.value));
  }

  unsubscribe(endpoint: string): Observable<boolean> {
    return this.api.request<BaseResponse>('DELETE', '/web-push/subscriptions', {body: {endpoint}})
      .pipe(map(r => r.status.toUpperCase() === 'OK'));
  }

  getSubscriptions(): Observable<WebPushSubscription[]> {
    return this.api.get<GenericCollectionResponse<WebPushSubscription>>('/web-push/subscriptions')
      .pipe(map(r => r.items));
  }
}
